import type { HttpErrorResponse, HttpRequest } from '@angular/common/http';

import { mensajeApiAmigable } from '../constants/mensajes-usuario';

/**
 * GET que cargan desde el shell para todos los usuarios; si fallan por RBAC no debe
 * taparse toda el área de trabajo (solo aviso compacto).
 */
const RBAC_403_BANNER_ONLY_SUBSTRINGS = ['/organizaciones/perfil', '/auth/me'] as const;

/**
 * GET que no deben bloquear la pantalla si fallan por RBAC (prefetch opcional o ya manejado en UI).
 */
const RBAC_403_OMIT_UI_GET_SUBSTRINGS = [
  '/organizaciones/perfil',
  '/usuarios',
  '/roles',
  '/configuracion-global',
  '/turnos-caja/actual',
] as const;

/** Mensaje típico del API: `{ "msg": "Permiso denegado: se requiere ORGANIZACION:VER" }`. */
export function extractRbacDeniedMessage(err: HttpErrorResponse): string | null {
  if (err.status !== 403) return null;
  const body = err.error;
  if (!body || typeof body !== 'object') return null;
  const msg = (body as { msg?: unknown }).msg;
  if (typeof msg !== 'string') return null;
  const t = msg.trim();
  if (!t) return null;
  if (/permiso\s+denegado/i.test(t)) return mensajeApiAmigable(t);
  if (/se\s+requiere/i.test(t) && /\b[A-Za-zÁÉÍÓÚÑáéíóúñ_]+:[A-Za-zÁÉÍÓÚÑáéíóúñ_]+\b/.test(t)) {
    return mensajeApiAmigable(t);
  }
  return null;
}

/** 403 esperable en GET opcionales; no mostrar banner ni velo (el componente sigue). */
export function rbac403OmitirUiSilencioso(req: HttpRequest<unknown>): boolean {
  if (req.method !== 'GET') return false;
  const u = req.url;
  return RBAC_403_OMIT_UI_GET_SUBSTRINGS.some((s) => u.includes(s));
}

/** @deprecated Usar rbac403OmitirUiSilencioso */
export function rbac403OmitirUiPerfilOrganizacion(req: HttpRequest<unknown>): boolean {
  return rbac403OmitirUiSilencioso(req);
}

/** Si conviene sólo banner (acciones POST/PATCH o GET global del shell). */
export function rbac403PreferBannerOnly(req: HttpRequest<unknown>): boolean {
  if (req.method !== 'GET') return true;
  const u = req.url;
  return RBAC_403_BANNER_ONLY_SUBSTRINGS.some((s) => u.includes(s));
}
